import modelEnhance from '@/utils/modelEnhance';

import { search_data } from '../service';

export default modelEnhance({
    namespace: 'badjs_realtime',
    state: {
        dataList: []
    },
    effects: {
        *searchData({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(search_data, payload);

                if (code) return false;

                yield put({
                    type: 'setData',
                    payload: data.list
                });

            } catch (e) {
                console.log(e);
            }
        }
    },
    reducers: {
        setData(state, { payload }) {
            return {
                ...state,
                dataList: payload
            };
        }
    }
});